/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelSupplementWorkflow200Response,
  CreateSupplementRequest,
  ExportSupplementPdf200Response,
  GetSupplementJustifications200Response,
  GetSupplementStats200Response,
  ListSupplementsResponse,
  Problem,
  Supplement,
  SupplementDetailed,
  SupplementJustification,
  SupplementStatus,
  SupplementWorkflowProgress,
  UpdateSupplementJustificationRequest,
  UpdateSupplementJustificationsRequest,
  UpdateSupplementJustificationsResponse,
  UpdateSupplementNameRequest,
  UpdateSupplementRequest,
  UpsertSupplementJustificationRequest,
} from '../models/index';
import {
    CancelSupplementWorkflow200ResponseFromJSON,
    CancelSupplementWorkflow200ResponseToJSON,
    CreateSupplementRequestFromJSON,
    CreateSupplementRequestToJSON,
    ExportSupplementPdf200ResponseFromJSON,
    ExportSupplementPdf200ResponseToJSON,
    GetSupplementJustifications200ResponseFromJSON,
    GetSupplementJustifications200ResponseToJSON,
    GetSupplementStats200ResponseFromJSON,
    GetSupplementStats200ResponseToJSON,
    ListSupplementsResponseFromJSON,
    ListSupplementsResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    SupplementFromJSON,
    SupplementToJSON,
    SupplementDetailedFromJSON,
    SupplementDetailedToJSON,
    SupplementJustificationFromJSON,
    SupplementJustificationToJSON,
    SupplementStatusFromJSON,
    SupplementStatusToJSON,
    SupplementWorkflowProgressFromJSON,
    SupplementWorkflowProgressToJSON,
    UpdateSupplementJustificationRequestFromJSON,
    UpdateSupplementJustificationRequestToJSON,
    UpdateSupplementJustificationsRequestFromJSON,
    UpdateSupplementJustificationsRequestToJSON,
    UpdateSupplementJustificationsResponseFromJSON,
    UpdateSupplementJustificationsResponseToJSON,
    UpdateSupplementNameRequestFromJSON,
    UpdateSupplementNameRequestToJSON,
    UpdateSupplementRequestFromJSON,
    UpdateSupplementRequestToJSON,
    UpsertSupplementJustificationRequestFromJSON,
    UpsertSupplementJustificationRequestToJSON,
} from '../models/index';

export interface CancelSupplementWorkflowRequest {
    workflowId: string;
}

export interface CreateSupplementOperationRequest {
    createSupplementRequest: CreateSupplementRequest;
}

export interface DeleteSupplementRequest {
    supplementId: number;
}

export interface DeleteSupplementJustificationRequest {
    supplementId: number;
    justificationId: number;
}

export interface ExportSupplementExcelRequest {
    supplementId: number;
}

export interface ExportSupplementPdfRequest {
    supplementId: number;
}

export interface GetSupplementRequest {
    supplementId: number;
}

export interface GetSupplementJustificationsRequest {
    supplementId: number;
    page?: number;
    limit?: number;
}

export interface GetSupplementStatsRequest {
    claimId?: number;
}

export interface GetSupplementWorkflowProgressRequest {
    supplementId: number;
}

export interface GetSupplementWorkflowStateRequest {
    workflowId: string;
}

export interface ListClaimSupplementsRequest {
    claimId: number;
    page?: number;
    limit?: number;
    status?: SupplementStatus;
}

export interface ListSupplementsRequest {
    page?: number;
    limit?: number;
    claimId?: number;
    comparisonId?: number;
    status?: SupplementStatus;
}

export interface UpdateSupplementOperationRequest {
    supplementId: number;
    updateSupplementRequest: UpdateSupplementRequest;
}

export interface UpdateSupplementJustificationOperationRequest {
    supplementId: number;
    justificationId: number;
    updateSupplementJustificationRequest: UpdateSupplementJustificationRequest;
}

export interface UpdateSupplementJustificationTextsRequest {
    supplementId: number;
    updateSupplementJustificationsRequest: UpdateSupplementJustificationsRequest;
}

export interface UpdateSupplementNameOperationRequest {
    supplementId: number;
    updateSupplementNameRequest: UpdateSupplementNameRequest;
}

export interface UpsertSupplementJustificationOperationRequest {
    supplementId: number;
    upsertSupplementJustificationRequest: UpsertSupplementJustificationRequest;
}

/**
 * SupplementsApi - interface
 * 
 * @export
 * @interface SupplementsApiInterface
 */
export interface SupplementsApiInterface {
    /**
     * Cancels an in-progress supplement workflow
     * @summary Cancel a supplement workflow
     * @param {string} workflowId ID of the workflow to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    cancelSupplementWorkflowRaw(requestParameters: CancelSupplementWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelSupplementWorkflow200Response>>;

    /**
     * Cancels an in-progress supplement workflow
     * Cancel a supplement workflow
     */
    cancelSupplementWorkflow(requestParameters: CancelSupplementWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelSupplementWorkflow200Response>;

    /**
     * 
     * @summary Create a supplement
     * @param {CreateSupplementRequest} createSupplementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    createSupplementRaw(requestParameters: CreateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Supplement>>;

    /**
     * Create a supplement
     */
    createSupplement(requestParameters: CreateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Supplement>;

    /**
     * 
     * @summary Delete a supplement by id
     * @param {number} supplementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    deleteSupplementRaw(requestParameters: DeleteSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Delete a supplement by id
     */
    deleteSupplement(requestParameters: DeleteSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * 
     * @summary Delete a supplement justification
     * @param {number} supplementId ID of the supplement
     * @param {number} justificationId ID of the justification to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    deleteSupplementJustificationRaw(requestParameters: DeleteSupplementJustificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a supplement justification
     */
    deleteSupplementJustification(requestParameters: DeleteSupplementJustificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Generate and download an Excel export of the supplement with all line items and justifications
     * @summary Export supplement as Excel
     * @param {number} supplementId ID of the supplement to export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    exportSupplementExcelRaw(requestParameters: ExportSupplementExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Generate and download an Excel export of the supplement with all line items and justifications
     * Export supplement as Excel
     */
    exportSupplementExcel(requestParameters: ExportSupplementExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Request PDF generation via Lambda. Returns immediately with status and download URL if cached, or processing status if generating.
     * @summary Export supplement as PDF via Lambda
     * @param {number} supplementId ID of the supplement to export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    exportSupplementPdfRaw(requestParameters: ExportSupplementPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportSupplementPdf200Response>>;

    /**
     * Request PDF generation via Lambda. Returns immediately with status and download URL if cached, or processing status if generating.
     * Export supplement as PDF via Lambda
     */
    exportSupplementPdf(requestParameters: ExportSupplementPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportSupplementPdf200Response>;

    /**
     * 
     * @summary Get a supplement by id with full details including lines
     * @param {number} supplementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    getSupplementRaw(requestParameters: GetSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementDetailed>>;

    /**
     * Get a supplement by id with full details including lines
     */
    getSupplement(requestParameters: GetSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementDetailed>;

    /**
     * Get all justifications for a supplement with pagination
     * @summary Get supplement justifications (paginated)
     * @param {number} supplementId ID of the supplement
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    getSupplementJustificationsRaw(requestParameters: GetSupplementJustificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupplementJustifications200Response>>;

    /**
     * Get all justifications for a supplement with pagination
     * Get supplement justifications (paginated)
     */
    getSupplementJustifications(requestParameters: GetSupplementJustificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupplementJustifications200Response>;

    /**
     * Returns statistics about supplements including counts by status
     * @summary Get supplement statistics
     * @param {number} [claimId] Optional claim ID to filter statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    getSupplementStatsRaw(requestParameters: GetSupplementStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupplementStats200Response>>;

    /**
     * Returns statistics about supplements including counts by status
     * Get supplement statistics
     */
    getSupplementStats(requestParameters: GetSupplementStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupplementStats200Response>;

    /**
     * Returns the current status and progress of the workflow processing a supplement
     * @summary Get supplement workflow progress by supplement ID
     * @param {number} supplementId ID of the supplement to check workflow progress for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    getSupplementWorkflowProgressRaw(requestParameters: GetSupplementWorkflowProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementWorkflowProgress>>;

    /**
     * Returns the current status and progress of the workflow processing a supplement
     * Get supplement workflow progress by supplement ID
     */
    getSupplementWorkflowProgress(requestParameters: GetSupplementWorkflowProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementWorkflowProgress>;

    /**
     * Returns the current state and progress of a supplement workflow
     * @summary Get supplement workflow state by workflow ID
     * @param {string} workflowId ID of the workflow to retrieve state for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    getSupplementWorkflowStateRaw(requestParameters: GetSupplementWorkflowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementWorkflowProgress>>;

    /**
     * Returns the current state and progress of a supplement workflow
     * Get supplement workflow state by workflow ID
     */
    getSupplementWorkflowState(requestParameters: GetSupplementWorkflowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementWorkflowProgress>;

    /**
     * 
     * @summary List supplements for a claim
     * @param {number} claimId 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {SupplementStatus} [status] Optional supplement status filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    listClaimSupplementsRaw(requestParameters: ListClaimSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSupplementsResponse>>;

    /**
     * List supplements for a claim
     */
    listClaimSupplements(requestParameters: ListClaimSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSupplementsResponse>;

    /**
     * 
     * @summary List supplements
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {number} [claimId] Filter by claim ID
     * @param {number} [comparisonId] Filter by comparison ID
     * @param {SupplementStatus} [status] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    listSupplementsRaw(requestParameters: ListSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSupplementsResponse>>;

    /**
     * List supplements
     */
    listSupplements(requestParameters: ListSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSupplementsResponse>;

    /**
     * 
     * @summary Update a supplement by id
     * @param {number} supplementId 
     * @param {UpdateSupplementRequest} updateSupplementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    updateSupplementRaw(requestParameters: UpdateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Supplement>>;

    /**
     * Update a supplement by id
     */
    updateSupplement(requestParameters: UpdateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Supplement>;

    /**
     * 
     * @summary Update a supplement justification
     * @param {number} supplementId ID of the supplement
     * @param {number} justificationId ID of the justification to update
     * @param {UpdateSupplementJustificationRequest} updateSupplementJustificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    updateSupplementJustificationRaw(requestParameters: UpdateSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementJustification>>;

    /**
     * Update a supplement justification
     */
    updateSupplementJustification(requestParameters: UpdateSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementJustification>;

    /**
     * 
     * @summary Update texts for multiple supplement justifications
     * @param {number} supplementId ID of the supplement
     * @param {UpdateSupplementJustificationsRequest} updateSupplementJustificationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    updateSupplementJustificationTextsRaw(requestParameters: UpdateSupplementJustificationTextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSupplementJustificationsResponse>>;

    /**
     * Update texts for multiple supplement justifications
     */
    updateSupplementJustificationTexts(requestParameters: UpdateSupplementJustificationTextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSupplementJustificationsResponse>;

    /**
     * Update the display name of a supplement
     * @summary Update supplement name
     * @param {number} supplementId Supplement ID
     * @param {UpdateSupplementNameRequest} updateSupplementNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    updateSupplementNameRaw(requestParameters: UpdateSupplementNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementDetailed>>;

    /**
     * Update the display name of a supplement
     * Update supplement name
     */
    updateSupplementName(requestParameters: UpdateSupplementNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementDetailed>;

    /**
     * Upsert (create or update) a justification for a supplement. If a justification already exists for the given lineItemMatchGroupId or lineItemId, it will be updated. Otherwise, a new justification will be created.
     * @summary Create or update a supplement justification
     * @param {number} supplementId ID of the supplement
     * @param {UpsertSupplementJustificationRequest} upsertSupplementJustificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplementsApiInterface
     */
    upsertSupplementJustificationRaw(requestParameters: UpsertSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementJustification>>;

    /**
     * Upsert (create or update) a justification for a supplement. If a justification already exists for the given lineItemMatchGroupId or lineItemId, it will be updated. Otherwise, a new justification will be created.
     * Create or update a supplement justification
     */
    upsertSupplementJustification(requestParameters: UpsertSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementJustification>;

}

/**
 * 
 */
export class SupplementsApi extends runtime.BaseAPI implements SupplementsApiInterface {

    /**
     * Cancels an in-progress supplement workflow
     * Cancel a supplement workflow
     */
    async cancelSupplementWorkflowRaw(requestParameters: CancelSupplementWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelSupplementWorkflow200Response>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling cancelSupplementWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplement-workflows/{workflowId}/cancel`.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelSupplementWorkflow200ResponseFromJSON(jsonValue));
    }

    /**
     * Cancels an in-progress supplement workflow
     * Cancel a supplement workflow
     */
    async cancelSupplementWorkflow(requestParameters: CancelSupplementWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelSupplementWorkflow200Response> {
        const response = await this.cancelSupplementWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a supplement
     */
    async createSupplementRaw(requestParameters: CreateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Supplement>> {
        if (requestParameters['createSupplementRequest'] == null) {
            throw new runtime.RequiredError(
                'createSupplementRequest',
                'Required parameter "createSupplementRequest" was null or undefined when calling createSupplement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSupplementRequestToJSON(requestParameters['createSupplementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementFromJSON(jsonValue));
    }

    /**
     * Create a supplement
     */
    async createSupplement(requestParameters: CreateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Supplement> {
        const response = await this.createSupplementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a supplement by id
     */
    async deleteSupplementRaw(requestParameters: DeleteSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling deleteSupplement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a supplement by id
     */
    async deleteSupplement(requestParameters: DeleteSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteSupplementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a supplement justification
     */
    async deleteSupplementJustificationRaw(requestParameters: DeleteSupplementJustificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling deleteSupplementJustification().'
            );
        }

        if (requestParameters['justificationId'] == null) {
            throw new runtime.RequiredError(
                'justificationId',
                'Required parameter "justificationId" was null or undefined when calling deleteSupplementJustification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/justifications/{justificationId}`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))).replace(`{${"justificationId"}}`, encodeURIComponent(String(requestParameters['justificationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a supplement justification
     */
    async deleteSupplementJustification(requestParameters: DeleteSupplementJustificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSupplementJustificationRaw(requestParameters, initOverrides);
    }

    /**
     * Generate and download an Excel export of the supplement with all line items and justifications
     * Export supplement as Excel
     */
    async exportSupplementExcelRaw(requestParameters: ExportSupplementExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling exportSupplementExcel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/export/excel`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Generate and download an Excel export of the supplement with all line items and justifications
     * Export supplement as Excel
     */
    async exportSupplementExcel(requestParameters: ExportSupplementExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportSupplementExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request PDF generation via Lambda. Returns immediately with status and download URL if cached, or processing status if generating.
     * Export supplement as PDF via Lambda
     */
    async exportSupplementPdfRaw(requestParameters: ExportSupplementPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportSupplementPdf200Response>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling exportSupplementPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/export/pdf`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportSupplementPdf200ResponseFromJSON(jsonValue));
    }

    /**
     * Request PDF generation via Lambda. Returns immediately with status and download URL if cached, or processing status if generating.
     * Export supplement as PDF via Lambda
     */
    async exportSupplementPdf(requestParameters: ExportSupplementPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportSupplementPdf200Response> {
        const response = await this.exportSupplementPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a supplement by id with full details including lines
     */
    async getSupplementRaw(requestParameters: GetSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementDetailed>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling getSupplement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementDetailedFromJSON(jsonValue));
    }

    /**
     * Get a supplement by id with full details including lines
     */
    async getSupplement(requestParameters: GetSupplementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementDetailed> {
        const response = await this.getSupplementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all justifications for a supplement with pagination
     * Get supplement justifications (paginated)
     */
    async getSupplementJustificationsRaw(requestParameters: GetSupplementJustificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupplementJustifications200Response>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling getSupplementJustifications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/justifications`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupplementJustifications200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all justifications for a supplement with pagination
     * Get supplement justifications (paginated)
     */
    async getSupplementJustifications(requestParameters: GetSupplementJustificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupplementJustifications200Response> {
        const response = await this.getSupplementJustificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns statistics about supplements including counts by status
     * Get supplement statistics
     */
    async getSupplementStatsRaw(requestParameters: GetSupplementStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupplementStats200Response>> {
        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupplementStats200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns statistics about supplements including counts by status
     * Get supplement statistics
     */
    async getSupplementStats(requestParameters: GetSupplementStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupplementStats200Response> {
        const response = await this.getSupplementStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the current status and progress of the workflow processing a supplement
     * Get supplement workflow progress by supplement ID
     */
    async getSupplementWorkflowProgressRaw(requestParameters: GetSupplementWorkflowProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementWorkflowProgress>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling getSupplementWorkflowProgress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplement-workflows/supplement/{supplementId}`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementWorkflowProgressFromJSON(jsonValue));
    }

    /**
     * Returns the current status and progress of the workflow processing a supplement
     * Get supplement workflow progress by supplement ID
     */
    async getSupplementWorkflowProgress(requestParameters: GetSupplementWorkflowProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementWorkflowProgress> {
        const response = await this.getSupplementWorkflowProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the current state and progress of a supplement workflow
     * Get supplement workflow state by workflow ID
     */
    async getSupplementWorkflowStateRaw(requestParameters: GetSupplementWorkflowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementWorkflowProgress>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling getSupplementWorkflowState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplement-workflows/{workflowId}`.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementWorkflowProgressFromJSON(jsonValue));
    }

    /**
     * Returns the current state and progress of a supplement workflow
     * Get supplement workflow state by workflow ID
     */
    async getSupplementWorkflowState(requestParameters: GetSupplementWorkflowStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementWorkflowProgress> {
        const response = await this.getSupplementWorkflowStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List supplements for a claim
     */
    async listClaimSupplementsRaw(requestParameters: ListClaimSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSupplementsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling listClaimSupplements().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/supplements`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSupplementsResponseFromJSON(jsonValue));
    }

    /**
     * List supplements for a claim
     */
    async listClaimSupplements(requestParameters: ListClaimSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSupplementsResponse> {
        const response = await this.listClaimSupplementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List supplements
     */
    async listSupplementsRaw(requestParameters: ListSupplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSupplementsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['comparisonId'] != null) {
            queryParameters['comparisonId'] = requestParameters['comparisonId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSupplementsResponseFromJSON(jsonValue));
    }

    /**
     * List supplements
     */
    async listSupplements(requestParameters: ListSupplementsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSupplementsResponse> {
        const response = await this.listSupplementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a supplement by id
     */
    async updateSupplementRaw(requestParameters: UpdateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Supplement>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling updateSupplement().'
            );
        }

        if (requestParameters['updateSupplementRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSupplementRequest',
                'Required parameter "updateSupplementRequest" was null or undefined when calling updateSupplement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplementRequestToJSON(requestParameters['updateSupplementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementFromJSON(jsonValue));
    }

    /**
     * Update a supplement by id
     */
    async updateSupplement(requestParameters: UpdateSupplementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Supplement> {
        const response = await this.updateSupplementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a supplement justification
     */
    async updateSupplementJustificationRaw(requestParameters: UpdateSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementJustification>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling updateSupplementJustification().'
            );
        }

        if (requestParameters['justificationId'] == null) {
            throw new runtime.RequiredError(
                'justificationId',
                'Required parameter "justificationId" was null or undefined when calling updateSupplementJustification().'
            );
        }

        if (requestParameters['updateSupplementJustificationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSupplementJustificationRequest',
                'Required parameter "updateSupplementJustificationRequest" was null or undefined when calling updateSupplementJustification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/justifications/{justificationId}`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))).replace(`{${"justificationId"}}`, encodeURIComponent(String(requestParameters['justificationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplementJustificationRequestToJSON(requestParameters['updateSupplementJustificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementJustificationFromJSON(jsonValue));
    }

    /**
     * Update a supplement justification
     */
    async updateSupplementJustification(requestParameters: UpdateSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementJustification> {
        const response = await this.updateSupplementJustificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update texts for multiple supplement justifications
     */
    async updateSupplementJustificationTextsRaw(requestParameters: UpdateSupplementJustificationTextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSupplementJustificationsResponse>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling updateSupplementJustificationTexts().'
            );
        }

        if (requestParameters['updateSupplementJustificationsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSupplementJustificationsRequest',
                'Required parameter "updateSupplementJustificationsRequest" was null or undefined when calling updateSupplementJustificationTexts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/justifications/texts`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplementJustificationsRequestToJSON(requestParameters['updateSupplementJustificationsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSupplementJustificationsResponseFromJSON(jsonValue));
    }

    /**
     * Update texts for multiple supplement justifications
     */
    async updateSupplementJustificationTexts(requestParameters: UpdateSupplementJustificationTextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSupplementJustificationsResponse> {
        const response = await this.updateSupplementJustificationTextsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the display name of a supplement
     * Update supplement name
     */
    async updateSupplementNameRaw(requestParameters: UpdateSupplementNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementDetailed>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling updateSupplementName().'
            );
        }

        if (requestParameters['updateSupplementNameRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSupplementNameRequest',
                'Required parameter "updateSupplementNameRequest" was null or undefined when calling updateSupplementName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/name`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplementNameRequestToJSON(requestParameters['updateSupplementNameRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementDetailedFromJSON(jsonValue));
    }

    /**
     * Update the display name of a supplement
     * Update supplement name
     */
    async updateSupplementName(requestParameters: UpdateSupplementNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementDetailed> {
        const response = await this.updateSupplementNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert (create or update) a justification for a supplement. If a justification already exists for the given lineItemMatchGroupId or lineItemId, it will be updated. Otherwise, a new justification will be created.
     * Create or update a supplement justification
     */
    async upsertSupplementJustificationRaw(requestParameters: UpsertSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplementJustification>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling upsertSupplementJustification().'
            );
        }

        if (requestParameters['upsertSupplementJustificationRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertSupplementJustificationRequest',
                'Required parameter "upsertSupplementJustificationRequest" was null or undefined when calling upsertSupplementJustification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/supplements/{supplementId}/justifications/upsert`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertSupplementJustificationRequestToJSON(requestParameters['upsertSupplementJustificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplementJustificationFromJSON(jsonValue));
    }

    /**
     * Upsert (create or update) a justification for a supplement. If a justification already exists for the given lineItemMatchGroupId or lineItemId, it will be updated. Otherwise, a new justification will be created.
     * Create or update a supplement justification
     */
    async upsertSupplementJustification(requestParameters: UpsertSupplementJustificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplementJustification> {
        const response = await this.upsertSupplementJustificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
